<!--
  A LoadingIndicator that is displayed while a promise is on-flight.
-->
<script setup lang="ts">
const { loadingUntil } = defineProps<{ loadingUntil: Promise<unknown> | undefined }>()

let displayLoadingIndicator = $ref(Boolean(loadingUntil))

watch($$(loadingUntil), () => {
  if (loadingUntil) displayLoadingIndicator = true
  handleLoadingUntil()
})

onMounted(handleLoadingUntil)

function handleLoadingUntil () {
  loadingUntil?.finally(() => { displayLoadingIndicator = false })
}
</script>

<template>
  <XLoadingIndicator v-if="displayLoadingIndicator" size="sm"/>
</template>
